const saleReducer = (state = {}, { type, payload }) => {
  switch (type) {
    case "setSale":
      return payload;
    default:
      return state;
  }
};

export default saleReducer;
